// extracted by mini-css-extract-plugin
module.exports = {"ApplyConstract":"index-module_ApplyConstract_6_bBG","content":"index-module_content_U8ZXv","title":"index-module_title_3Mkwg","paragraph":"index-module_paragraph_10Ew5"};